import api from "./api";

export const getVaultDocumentTypesAndDims = (query, options) =>
  api.get({
    path: "/documents/get-document-types-dims",
    query,
    options,
  });

export const getVaultDocument = (query, options) =>
  api.get({
    path: "/documents/",
    query,
    options,
  });

export const uploadDocumentToVault = (body, options) =>
  api.post({
    path: "/documents/",
    body,
    options,
  });
